import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Inject, Input, input, Output } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';

export interface GenericDialogData {
  title: string;
  subTitle:string|null;
  onCancelText: string |null;
  onConfirmText: string |null;
  onCancel: ()=>{};
  onConfirm: ()=>{};
}


@Component({
  selector: 'app-generic-dialog',
  imports: [],
  templateUrl: './generic-dialog.dialog.html',
  styleUrl: './generic-dialog.dialog.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenericDialogComponent {
  
  constructor( private ref: DialogRef, @Inject(DIALOG_DATA) public data: GenericDialogData){}

  close(){
    this.ref.close();
  }

  get cancelText(){
    return this.data.onCancelText ?? 'Cancel'
  }

  get confirmText(){
    return this.data.onConfirmText ?? 'Confirm'
  }

}
